import React from 'react';
import { EyeIcon, GraduationCapIcon, MicroscopeIcon, ZapIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { differentiators } from '../../data/content';
const icons = [MicroscopeIcon, EyeIcon, GraduationCapIcon, ZapIcon];
export function DifferentSection() {
  return <section aria-labelledby="different-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-72" data-mp="3mbmhaaw5m4a7">
      <div className="mx-auto max-w-5xl" data-id="element-73" data-mp="3qb4zv00i639v">
        <SectionHeading id="different-heading" eyebrow="Why This Is Different" title={<>
              Not Another <Accent data-id="element-75" data-mp="3xn01hrr5spv">Generic Beauty Ebook.</Accent>
            </>} data-id="element-74" data-mp="3qac38rv9cu5g" />

        <ul className="mt-12 grid gap-x-12 sm:grid-cols-2" role="list" data-id="element-76" data-mp="8vya9tlym58m">
          {differentiators.map((item, index) => {
          const Icon = icons[index];
          return <li key={item.title} className="flex items-start gap-4 border-t border-brand-charcoal/12 py-7" data-id="element-77" data-mp="hw3gi0ff2xl7" data-mpi={index}>
                <Icon className="mt-1 h-6 w-6 flex-none text-brand-violet" strokeWidth={1.5} aria-hidden="true" data-id="element-78" data-mp="2a9izwuqp5j8o" />
                <div data-id="element-79" data-mp="258v6k2ezwqba">
                  <h3 className="font-display text-[1.6rem] font-bold leading-tight text-brand-charcoal" data-id="element-80" data-mp="258bs4vok0k20">{item.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-81" data-mp="20cmyta34nze5">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[2rem] font-bold leading-[1.15] text-brand-charcoal sm:text-[2.6rem]" data-id="element-82" data-mp="2sypi8gnkw8ty">
          Don’t just teach students <span className="text-brand-violet" data-id="element-83" data-mp="2j8mjs0xou2o8">WHAT</span> to do. Help them understand{' '}
          <Accent data-id="element-84" data-mp="2e9jmx3rv32rc">WHY.</Accent>
        </p>
      </div>
    </section>;
}